import { render, staticRenderFns } from "./ListaStakeholder.vue?vue&type=template&id=751fa3c6&scoped=true&"
import script from "./ListaStakeholder.vue?vue&type=script&lang=js&"
export * from "./ListaStakeholder.vue?vue&type=script&lang=js&"
import style0 from "./ListaStakeholder.vue?vue&type=style&index=0&id=751fa3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751fa3c6",
  null
  
)

export default component.exports